module.exports = __webpack_public_path__ + "img/selected2-min.3cab4896.png";